import { useParams } from '@tanstack/react-router'

import { Tabs, TabsList, TabsTriggerAsLink } from '@/components/tabs'

interface Props {
    active: 'profile' | 'users' | 'apiKeys' | 'invitations'
}

export default function SettingsNavigation({ active }: Props) {
    const params = useParams({ strict: false }) as any
    return (
        <Tabs>
            <TabsList>
                <TabsTriggerAsLink to="/$client_code/settings" params={params} active={active === 'profile'}>
                    Profile
                </TabsTriggerAsLink>
                <TabsTriggerAsLink to="/$client_code/settings/users" params={params} active={active === 'users'}>
                    Users
                </TabsTriggerAsLink>
                <TabsTriggerAsLink
                    to="/$client_code/settings/invitations"
                    params={params}
                    active={active === 'invitations'}
                >
                    Invitations
                </TabsTriggerAsLink>
                <TabsTriggerAsLink to="/$client_code/settings/apikeys" params={params} active={active === 'apiKeys'}>
                    API Keys
                </TabsTriggerAsLink>
            </TabsList>
        </Tabs>
    )
}
